// @ts-nocheck
import {
    AnchorContext,
    AnchorContextModel,
    AnchorLink,
} from "@store/Framework/Components/AnchorContext/AnchorContext";
import React, { FC, PropsWithChildren, useState } from "react";

const reorder = (links: AnchorLink[]) => {
    if (typeof window === "undefined") {
        return links;
    }

    const sortOrder = Array.from(window.document.querySelectorAll(links.map(x => `#${x.id}`).join(", ")), x => x.id);
    const orderedLinks = [...links].sort((a, b) => sortOrder.indexOf(a.id) - sortOrder.indexOf(b.id));

    return orderedLinks;
};

const update = (links: AnchorLink[], link: AnchorLink) => {
    return reorder(
        links.reduce((result, x) => {
            return [...result, x.uid === link.uid ? link : x];
        }, [] as AnchorLink[]),
    );
};

const addOrUpdate = (links: AnchorLink[], link: AnchorLink) => {
    return links.some(x => x.uid === link.uid) ? update(links, link) : [...links, link];
};

const remove = (links: AnchorLink[], uid: string) => {
    return links.reduce((result, x) => {
        return x.uid === uid ? result : [...result, x];
    }, [] as AnchorLink[]);
};

export const AnchorContextProvider: FC<PropsWithChildren> = ({ children }) => {
    const [links, setLinks] = useState<AnchorContextModel["links"]>([]);

    const addOrUpdateLink: AnchorContextModel["addOrUpdateLink"] = link => {
        setLinks(x => reorder(addOrUpdate(x, link)));
    };

    const removeLink: AnchorContextModel["removeLink"] = uid => {
        setLinks(x => remove(x, uid));
    };

    return <AnchorContext.Provider value={{ addOrUpdateLink, links, removeLink }}>{children}</AnchorContext.Provider>;
};
